import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getTransHistory = (state: AppState) => state.transHistory;
const getResTransHistory = (state: AppState) => state.transHistory.responseTransHistory;
const getPending = (state: AppState) => state.transHistory.pending;

export const getTransHistorySelector = createSelector(getTransHistory, (data) => data);

export const getResTransHistorySelector = createSelector(getResTransHistory, (data) => data);

export const getPendingTransHistorySelector = createSelector(getPending, (status) => status);
